import React, { useEffect, useState, useMemo, useCallback } from "react";
import useBackboneContext from "@src/backbone/provider/useBackboneContext";
import MessageModel from "@src/backbone/model/MessageModel";
import { useCurrentPageContextIntl } from "@src/store/reducers/PageSlice/selectors";
import { useAppSelector } from "@src/store/hooks";
import StandardBanner, {
  IStandardBannerMessage,
  IStandardBannerProps,
} from "./StandardBanner";

export const StandardBannerWrapper = (
  props: Pick<IStandardBannerProps, "onToggleTopBanner">
) => {
  const { onToggleTopBanner } = props;
  const [currentMessageModel, setCurrentMessageModelModel] = useState<
    MessageModel | undefined
  >();
  const { models, app } = useBackboneContext();
  const currentPageContext = useCurrentPageContextIntl();
  const { hideTopBanner } = useAppSelector(({ cart }) => cart);
  const [message, setMessage] = useState<IStandardBannerMessage | null>(null);

  const messageLocationSlug = useMemo(() => {
    let messageSource: "home_top_banner" | "listing_top_banner" | "" = "";
    const { pageTemplate = "" } = { ...currentPageContext };
    if (pageTemplate === "Home") {
      messageSource = "home_top_banner";
    } else if (pageTemplate === "Category") {
      messageSource = "listing_top_banner";
    }
    return messageSource;
  }, [currentPageContext]);

  useEffect(() => {
    const messages = app.getMessages(),
      message = app.getMessage(messageLocationSlug);
    if (message) {
      setCurrentMessageModelModel(message);
    } else {
      setCurrentMessageModelModel(undefined);
    }
    const handleMessageChange = () => {
      setCurrentMessageModelModel(app.getMessage(messageLocationSlug));
    };
    messages.on("change", handleMessageChange);
    app.on("change:message", handleMessageChange); // setup
    return () => {
      messages.off("change", handleMessageChange);
      app.off("change:message", handleMessageChange); // setup
    };
  }, [app, messageLocationSlug, models]);

  useEffect(() => {
    if (currentMessageModel && !currentMessageModel.get("dismissed")) {
      setMessage({
        id: (currentMessageModel.id as string) || "",
        text: currentMessageModel.get("message") || "",
        link: currentMessageModel.get("link"),
        icon: currentMessageModel.get("icon"),
        backgroundColor: currentMessageModel.getBackgroundColor(),
      });
    } else {
      setMessage(null);
    }
  }, [currentMessageModel]);

  const handleClose = useCallback(() => {
    currentMessageModel?.dismiss();
    setMessage(null);
  }, [currentMessageModel]);

  if (!currentMessageModel || hideTopBanner || !message) {
    return null;
  }

  return <StandardBanner {...{ message, onToggleTopBanner, handleClose }} />;
};

export default StandardBannerWrapper;
